const loaderReducer = (state = [], {type, toggler}) => {
    switch(type){
        case 'TOGGLE_LOADER':
            return {isOpen: toggler}
        default:
            return state;
    }
}

export default loaderReducer;